import styled from 'styled-components'

export enum ContainerSubInfoPositionEnum {
  LEFT = 'left',
  RIGHT = 'right',
}

export const TagContainer = styled.div`
  display: flex;
  max-width: 11cm;
  max-height: 9cm;
  width: 11cm;
  height: 9cm;
  flex-direction: column;
  background-color: #000;
  padding: 5px;
  -webkit-print-color-adjust: exact;
`

export const TextHeader = styled.p<{ size?: number }>`
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: ${({ size = 16 }) => `${size}px`};
  font-weight: bold;
`

export const Text = styled.p`
  margin: 0;
  padding: 0;
  text-align: center;
  font-weight: bold;
  padding-right: 5px;
`

export const DescriptionText = styled(Text)`
  max-width: 500px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const TextFooter = styled.p<{ size?: number }>`
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: ${({ size = 16 }) => `${size}px`};
  font-weight: bold;
`

export const ContainerInfo = styled.div`
  background-color: #fff;
  display: flex;
  flex: 1;
  flex-direction: 'row';
  justify-content: start;
  align-items: center;
  margin: 2px;
  padding-left: 3px;
  padding-right: 3px;
`

export const ContainerInfos = styled.div`
  display: flex;
  flex: 1;
  flex-direction: 'row';
  justify-content: space-between;
  align-items: center;
`

export const ContainerSubInfo = styled.div<{ position?: ContainerSubInfoPositionEnum }>`
  background-color: #fff;
  display: flex;
  flex: 1;
  flex-direction: 'row';
  justify-content: start;
  align-items: center;
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: ${({ position }) =>
    (position === ContainerSubInfoPositionEnum.LEFT && '2px')
    || (position === ContainerSubInfoPositionEnum.RIGHT && '1px')
    || '2px'};
  margin-right: ${({ position }) =>
    (position === ContainerSubInfoPositionEnum.LEFT && '1px')
    || (position === ContainerSubInfoPositionEnum.RIGHT && '2px')
    || '2px'};
  padding-left: 3px;
  padding-right: 3px;
`

export const ContainerTitle = styled(ContainerInfo)`
  display: flex;
  justify-content: center;
  background-color: #000;
  & > p:nth-child(n) {
    color: #fff;
    font-size: 20px;
  }
`

export const ContainerAddress = styled(ContainerInfo)`
  display: flex;
  flex-direction: column;
  background-color: #000;
  & > p:nth-child(n) {
    color: #fff;
  }
`

export const AddressBlock = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #000;
  & > p:nth-child(n) {
    color: #fff;
  }
`
